<template>
  <div class="game-score" :class="{ 'game-score--app' : $inApp }">
    <img class="game-score__bg" src="/img/misc/score-bg.png" alt="banner score background">

    <p class="game-score__mt" v-html="`${$store.state.mt} mt`" />

    <div class="game-score__flower">
      <div class="game-score__circular" data-circle>
        <img src="/img/logo/flower-top.png" alt="flower score" data-icon>
      </div>

      <p class="game-score__circular-text" v-html="$store.state.score" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'GameScore',
};
</script>

<style lang="scss" scoped>
.game-score {
  position: fixed;
  top: 20px;
  right: 0;

  color: $red;

  &.game-score--app {
    top: 80px;
  }

  &__bg {
    min-width: 120px;
    max-width: 240px;
    width: 14vw;
    margin: 0;
  }

  &__mt {
    position: absolute;
    top: 15%;
    right: 20px;

    @extend %font-small;
  }

  &__flower {
    position: absolute;
    top: 52%;
    right: 20px;
    width: 100%;

    color: $white;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    img {
      position: absolute;
      display: inline-block;
      width: 80%;
      top: 20%;
      left: 10%;
    }
  }

  &__circular {
    position: relative;
    width: 25%;
    flex: 0 0 25%;
    margin: 0 10px 0 0;
    border-radius: 50%;
    background-color: $pink-light;

    @include aspect-ratio(1, 1);
  }

  @include mq(ipadP, $and: $is-not-touch-device) {
    &__mt {
      top: 10%;
      right: 30px;
    }

    &__flower {
      right: 30px;
    }

    &__circular {
      margin: 0 20px 0 0;
    }
  }
}
</style>
